import React, { useMemo } from 'react';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';
import { IconButton, Icon, Flex } from '@chakra-ui/react';

export default function FavoriteButtonV1({ productDetailId, onToggle, isOutOfStock }) {
  const { isFavorite, favorites } = webCore.contexts.useFavorites();

  const isFavoriteItem = useMemo(
    () => isFavorite(productDetailId),
    [isFavorite, productDetailId, favorites?.ids]
  );

  const onClick = (e) => {
    e.preventDefault();
    if (onToggle) {
      onToggle();
    }
  };

  return (
    <Flex
      ml="1px"
      w={{ base: 18 }}
      borderRadius="50%"
      borderWidth={0}
      borderStyle="solid"
      borderColor="primary.500"
      justifyContent="center"
      alignItems="center"
    >
      <IconButton
        variant="transparent"
        height="auto"
        justifyContent="flex-end"
        minWidth="unset"
        isDisabled={isOutOfStock}
        icon={
          <Icon
            as={webApp.theme.icons.FavoriteIcon}
            fill={isFavoriteItem ? 'red.300' : 'none'}
            stroke={isFavoriteItem ? 'none' : 'gray.400'}
            h={4}
            w={4}
          />
        }
        onClick={onClick}
      />
    </Flex>
  );
}
